<script lang="ts">
  import { slide } from 'svelte/transition';
  import { Cross } from '@athena-lib/Icons';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import type { InfoBannerProps } from './types';
  const { id, content, dismiss }: InfoBannerProps = $props();
  const translations = getCommonTranslations();
</script>

<div
  class="flex items-center justify-center gap-2 bg-st-yellow-200 p-1 text-center text-sm"
  out:slide={{ delay: 0, duration: 200 }}
>
  {#if typeof content === 'string'}
    {content}
  {:else}
    {@render content()}
  {/if}

  <button
    type="button"
    class="h-5 w-5"
    onclick={() => dismiss({ id, content })}
    aria-label={translations.closeText}
  >
    <Cross />
  </button>
</div>
